/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-08 23:33:24
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-01-24 15:01:48
 * @FilePath: /lobby/src/stores/languages.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { getLocale, setLocale } from '@/locales'
import { defineStore } from 'pinia'
// import { config } from '@/common/config'

export const useLanguagesStore = defineStore('languages', {
  state: () => {
    return {
      languages: [
        {
          text: 'አማርኛ',
          code: 'am',
          phone: 251,
          lang: 'አማርኛ'
        },
        {
          text: 'English',
          code: 'en',
          phone: 251,
          lang: 'English'
        },
        {
          text: 'FRANÇAIS',
          code: 'fr',
          phone: 225,
          lang: 'français'
        },
        {
          text: 'Kiswahili',
          code: 'sw',
          phone: 255,
          lang: 'Kiswahili'
        }
      ],
      currentLanguageCode: getLocale(),
      currentPhoneCode: 55
    }
  },
  getters: {
    currentLanguage() {
      return this.languages.find((item) => item.code === this.currentLanguageCode)
    },
    currentPhone() {
      return this.languages.find((item) => item.phone === this.currentPhoneCode)
    }
  },
  actions: {
    setLanguage(language) {
      const isSupport = this.languages.some((item) => item.code === language)
      if (isSupport && language !== this.currentLanguageCode) {
        console.log(`setLanguage new=${language} old=${this.currentLanguageCode}`)
        this.currentLanguageCode = language
        setLocale(language)
        location.reload()
        // const country = useUserStore().country
        // if (country == 'ET' || country == 'et') {
        //   window.location.replace('https://www.vivagame.et')
        // } else if (country == 'CI' || country == 'ci') {
        //   window.location.replace('https://www.vivagame.ci')
        // } else if (country == 'KE' || country == 'ke') {
        //   window.location.replace('https://www.vivagame.ke')
        // } else {
        //   location.reload()
        //   // Handle other cases or show an error message
        // }
      }
    },
    setPhone(phone) {
      this.currentPhoneCode = phone
      const isSupport = this.languages.some((item) => item.phone === phone)
      if (isSupport && phone !== this.currentPhoneCode) {
        console.log(`setPhone new=${phone} old=${this.currentPhoneCode}`)
        this.currentPhoneCode = phone
      }
    }
  }
})
